import React from "react";
import merge from "lodash/merge";
import HoverIconButton from "components/HoverIconButton";
import VideoModal from "components/VideoModal";

const DEFAULT_TRIGGER_PROPS = {
  customClasses: {
    button:
      "ma0 items-center flex pa0 dib items-center justify-center bn relative bg-white bg-white--hover"
  },
  icon: "help",
  size: 18
};

const PlayVideoTrigger = ({ id, triggerProps }) => {
  const ctxTriggerProps = merge({ ...DEFAULT_TRIGGER_PROPS }, triggerProps);
  if (!id) {
    return null;
  }

  return (
    <VideoModal id={id} trigger={<HoverIconButton {...ctxTriggerProps} />} />
  );
};

export default PlayVideoTrigger;
